<div class="rn-page">
  <div class="help-text-container">
    <h3>Congratulations!</h3>
    <i>Here are the details on what you created:</i>
  </div>
  <rn-setup-banner-autoresponse
    [clientId]="clientId"
  ></rn-setup-banner-autoresponse>
  <div class="rn-page__section">
    @if (isLoading()) {
      <div class="rn-page--busy">
        <app-spinner
          [styleRules]="{ transform: 'translateY(250px)' }"
        ></app-spinner>
      </div>
    } @else {
      @if (twoWayConfig) {
        @if (isFeedEnabled) {
          <h2>Relay Messenger Settings Summary</h2>
        }
        @if (!isFeedEnabled) {
          <h2>Two Way Settings Summary</h2>
        }
        <!-- Old Auto Responses -->
        @if (!isRMAutoResponseEnabled || !isFeedEnabled) {
          <div
            class="two-way-summary-container"
            >
            <h3>Auto Responses</h3>
            <div class="inline-col">
              <h4>Default</h4>
              <rn-generic-phone>
                @if (!defaultProductGroup) {
                  <app-spinner
                    [styleRules]="{ transform: 'translateY(100px)' }"
                  ></app-spinner>
                }
                @if (defaultProductGroup) {
                  <wire-header
                    [productGroup]="defaultProductGroup"
                  ></wire-header>
                }
                @if (defaultProductGroup) {
                  <two-way-preview
                    [productGroup]="defaultProductGroup"
                    [messageText]="twoWayConfig.default_auto_response"
                  ></two-way-preview>
                }
              </rn-generic-phone>
            </div>
            <div class="inline-col">
              <h4>After Hours</h4>
              <rn-generic-phone>
                @if (!defaultProductGroup) {
                  <app-spinner
                    [styleRules]="{ transform: 'translateY(100px)' }"
                  ></app-spinner>
                }
                @if (defaultProductGroup) {
                  <wire-header
                    [productGroup]="defaultProductGroup"
                  ></wire-header>
                }
                @if (defaultProductGroup) {
                  <two-way-preview
                    [productGroup]="defaultProductGroup"
                    [messageText]="twoWayConfig.after_hours_auto_response"
                  ></two-way-preview>
                }
              </rn-generic-phone>
            </div>
          </div>
        }
        <!-- New Auto Responses -->
        @if (isRMAutoResponseEnabled && isErrorAutoResponse) {
          <div>
            <p class="error-msg">
              Oops, there was an error loading Auto Responses preview. Please try
              refreshing
            </p>
          </div>
        }
        @if (
          isRMAutoResponseEnabled &&
          isFeedEnabled &&
          !isErrorAutoResponse &&
          autoResponseMessages
          ) {
          <div
            class="two-way-summary-container"
            >
            <h3>Auto Responses</h3>
            @for (autoResponseMessage of autoResponseMessages; track autoResponseMessage) {
              <div class="inline-col">
                <h4>{{ autoResponseMessage.title }}</h4>
                <div class="phone-container">
                  <rn-generic-phone>
                    <two-way-preview-react
                      [autoResponseMessage]="autoResponseMessage.message"
                      [brandingColor]="headerColor"
                      [isTranslationsEnabled]="isTranslationsEnabled"
                      [id]="'auto-response-preview-' + autoResponseMessage.id"
                    ></two-way-preview-react>
                  </rn-generic-phone>
                </div>
              </div>
            }
          </div>
        }
        <h3>{{ newFeed.enabled ? 'Notification' : 'SMS' }} Ping</h3>
        <h4>{{ newFeed.enabled ? 'Notification' : 'Message' }}</h4>
        @if (showUpdatedPingText) {
        @if (isErrorPingMessages) {
        <div>
          <p class="error-msg">
            Oops, there was an error loading Notification preview. Please try
            refreshing
          </p>
        </div>
        } @else if (pingSmsText) {
        <rn-generic-phone>
          <bubble [text]="pingSmsText"></bubble>
        </rn-generic-phone>
        } @else {
        <rn-generic-phone>
          <app-spinner [styleRules]="{ transform: 'translateY(100px)' }"></app-spinner>
        </rn-generic-phone>
        }
        } @else {
        <rn-generic-phone>
          <bubble [text]="twoWayConfig.sms.body + '\n' + twoWayConfig.sms.disclaimer"></bubble>
        </rn-generic-phone>
        }
        }
        }
  </div>
</div>
